import { Box, IconButton, Paper, Typography } from "@/common/styles/style";
import SearchBox from "@/molecules/searchBox";
import { styles } from "./style";
import { GroupsType, TenantsType } from "@/common/type/type";
import { MoreVert } from "@mui/icons-material";
import { getRoleName, roleInfo } from "@/helpers/getUserInfo";

interface TenantsProps {
  handleSearch: (searchType: string, value: string) => void;
  handlePopoverOpen: (
    event: React.MouseEvent<HTMLElement>,
    popoverContent: string | null
  ) => void;
  setSelectedTenant: (value: React.SetStateAction<TenantsType | null>) => void;
  setSelectedGroup: (value: React.SetStateAction<GroupsType | null>) => void;
  setIsUnassigned: (value: React.SetStateAction<boolean>) => void;
  handleMenuClick: (event: React.MouseEvent<HTMLElement>, name: string) => void;
  setClickId: (value: React.SetStateAction<number>) => void;
  tenantsList: TenantsType[];
  search: {
    tenant: string;
    group: string;
    user: string;
  };
  userRole: number;
  selectedTenant: TenantsType | null;
}

export default function Tenants({
  handleSearch,
  handlePopoverOpen,
  setSelectedTenant,
  setSelectedGroup,
  setIsUnassigned,
  handleMenuClick,
  setClickId,
  tenantsList,
  search,
  userRole,
  selectedTenant,
}: TenantsProps) {
  return (
    <Paper sx={styles.paper}>
      <Box sx={styles.paperSearchWrapper}>
        <SearchBox
          searchType="addPlusBtn"
          onSearch={(value) => handleSearch("tenant", value)}
          handleAddButton={(e) =>
            handlePopoverOpen(e as React.MouseEvent<HTMLElement>, "tenant")
          }
        />
      </Box>
      <Box mt={2} sx={styles.paperTitle}>
        <Typography variant="h6">テナント一覧</Typography>
      </Box>
      <Box mt={2} sx={styles.paperList}>
        {tenantsList &&
          tenantsList
            .filter(
              (tenant) =>
                typeof tenant.name === "string" &&
                typeof search.tenant === "string" &&
                tenant.name.toLowerCase().includes(search.tenant.toLowerCase())
            )
            .map((tenant, index) => (
              <Box
                key={index}
                sx={{
                  ...styles.listItem,
                  ...(selectedTenant?.id === tenant.id ? styles.selectedItem : {}),
                }}
                onClick={() => {
                  setIsUnassigned(false);
                  setSelectedGroup(null);
                  setSelectedTenant(tenant);
                  setClickId(tenant.id);
                }}
              >
                <Typography>{tenant.name}</Typography>
                {getRoleName(userRole) === roleInfo.admin ? (
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleMenuClick(e, tenant.name);
                    }}
                  >
                    <MoreVert />
                  </IconButton>
                ) : null}
              </Box>
            ))}
      </Box>
    </Paper>
  );
}
